import React, { Component } from 'react'
import ReactDom from 'react-dom'
import { CSSTransition } from 'react-transition-group'
import s from './style.module.scss'
import './style.scss'

class Dialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false
    }
    if (props.onRef) {
      props.onRef(this)
    }
    this.close = this.close.bind(this)
  }
  render() {
    let { show } = this.state
    let { text } = this.props
    return (
      show && (
        <CSSTransition
          in={show}
          classNames="dialog"
          timeout={300}
          unmountOnExit
        >
          <div className={s['dialog-wrap']}>
            <div className={s['dialog-box']}>
              <div className={s['content']}>
                <span>{text}</span>
              </div>
              <div className={s['btn']} onClick={this.close}>
                知道了
              </div>
            </div>
          </div>
        </CSSTransition>
      )
    )
  }
  show() {
    this.setState({ show: true })
  }
  close() {
    this.setState({ show: false }, () => {
      this.props.parent.destroy()
    })
  }
}

function createDialog(text = 'hello dialog') {
  let div = document.createElement('div')
  document.body.appendChild(div)
  let dialogRef
  let parent = {
    show() {
      return dialogRef.show()
    },
    close() {
      return dialogRef.close()
    },
    destroy() {
      ReactDom.unmountComponentAtNode(div)
      document.body.removeChild(div)
    }
  }
  ReactDom.render(
    <Dialog
      text={text}
      parent={parent}
      ref={ref => {
        dialogRef = ref
      }}
    />,
    div
  )
  return parent
}

export default createDialog
